import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FastAPIService, News, Solver, SentimentResults } from 'src/app/service/fast-api.service';

@Component({
  selector: 'app-box-results',
  templateUrl: './box-results.component.html',
  styleUrls: ['./box-results.component.scss']
})
export class BoxResultsComponent {
  image_path = "assets/search-component-images/";

  result_corner_icon = this.image_path + "result-corner-icon.svg";
  view_icon = this.image_path + "view_icon.svg";
  mapPin_icon = this.image_path + "MapPin.svg"

  filter = new Solver().solve().filter;

  constructor(public fastService: FastAPIService) { }

  @Input() results: News[] = [];
  @Input() loading: boolean = true;
  @Input() skeleton: boolean = false;
  @Input() reachTheEnd: boolean = false;

  @Output() onResultClick: EventEmitter<News> = new EventEmitter();
  @Output() onRequestMoreSearchResults: EventEmitter<any> = new EventEmitter();
  @Output() onMapButtonClick: EventEmitter<News> = new EventEmitter();

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.fastService.getDefaultImage();
  }
  getSentimentTooltip(sentiment: SentimentResults) {
    if (sentiment) {
      return `ข่าวมีโอกาสเป็น เชิงบวก ${(sentiment.pos * 100).toFixed(2)}%, เชิงลบ ${(sentiment.neg * 100).toFixed(2)}% และเป็นกลาง ${(sentiment.neu * 100).toFixed(2)}%`;
    }
    return ''
  }
}
